module.exports = __webpack_public_path__ + "assets/e2a61a74313453bd866be14ca91b8cae.png";